<template>
  <div>
    <div class="steps">
      <template v-for="(step, i) in steps">
        <div
          v-if="i > 0"
          :key="'segment-' + step.id"
          :class="{ segment: true, done: isCompleted(step.id) }"
        ></div>
        <button
          :key="'button-' + step.id"
          :class="{
            button: true,
            completed: isCompleted(step.id),
            locked: locked,
            remaining: !isCompleted(step.id),
            active: step.id === activeStep
          }"
          @click.prevent="onClick(step)"
        >
          <div :key="'bubble-' + step.id" class="bubble"></div>
          <span :key="'name-' + step.id" class="name">
            {{ step.name }}
          </span>
        </button>
        <div
          v-if="step.id === activeStep"
          :key="'label-' + step.id"
          class="step-label"
        >
          {{ step.name }}
        </div>
      </template>
    </div>
    <div class="steps-progress">
      <div
        v-for="step in steps"
        :key="'progress-' + step.id"
        :class="{ segment: true, done: isCompleted(step.id) }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'activeStep',
    event: 'selected'
  },
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    activeStep: {
      type: [String, Number],
      default: null
    },
    completedSteps: {
      type: Array,
      default: () => []
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isCompleted(stepId) {
      return this.completedSteps.includes(stepId);
    },
    onClick(step) {
      if (!this.locked && this.isCompleted(step.id)) {
        this.$emit('selected', step.id);
      }
    }
  }
};
</script>
